import defaultImage from "../../assets/images/default.jpg";
import { baseURL } from "../../util/config";


const formatImageUrl = (imageUrl) => {
  if (!imageUrl) return defaultImage;

  let formattedUrl = imageUrl.replace(/\\/g, '/');

  // Replace localhost URLs with the actual baseURL for mobile compatibility
  if (formattedUrl.includes('localhost:3000')) {
    formattedUrl = formattedUrl.replace(/http:\/\/localhost:3000\/?/g, baseURL);
  }

  if (!formattedUrl.startsWith('http')) {
    formattedUrl = `${baseURL}${formattedUrl}`;
  }

  return formattedUrl;
};

export default formatImageUrl;